import React from 'react'

export default function YearlySalesInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        #yearly-sales-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }
        .yearly-sales-table td { padding: 5px 10px; }
        .yearly-sales-table th { padding: 10px 10px; }

        .striped tbody:nth-child(even) { background-color: #F7FFF7; }
        .yearly-sales-table thead { background-color: #A7ADB8; }
        .yearly-sales-table .total { background-color: lightblue; font-weight: bold; }

        .data-and-chart-container { display: flex; }
        .left-wrapper { flex: 1.1; }
        .right-wrapper { flex: 3; padding: 10px; }

        .yearly-sales-chart {
          /*background-color: #EBEBEB;*/
          display: flex;
          /*height: 100%;*/
        }
        .yearly-sales-chart { }

        .yearly-sales-table {
          width: 100%;
          border-spacing: 0;
          font-size: 1rem;
          border: solid 0.5px lightgrey;
        }

        .yearly-sales-table th:nth-child(1), .inventory-table td:nth-child(1) { width: 20%; }
        .yearly-sales-table th:nth-child(2), .inventory-table td:nth-child(2) { width: 40%; }
        .yearly-sales-table th:nth-child(3), .inventory-table td:nth-child(3) { width: 40%; }
      `}
      </style>
    </React.Fragment>
  )
}
